module.exports = __webpack_public_path__ + "img/zilliqa-logo-big.684cdad9.svg";